import { createLocaleManager, Locales, useLocale } from '@previo/core'
import { Language, type LanguageId } from '@previo/codebooks'

const pmsLocaleManager = createLocaleManager({ reloadOnChange: true })

/**
 * P1 is the source of truth for the user's language and can change it behind PMS's back
 * (e.g., when switching language in the legacy app). Reconciles PMS's cached locale with it
 * on load, without the reload `pmsLocaleManager.setLocale` would otherwise trigger.
 */
const syncLocaleWithUserLanguage = (languageId: LanguageId): void => {
  const locale = Language.getById(languageId).shortcut as string as Locales

  if (!Object.values(Locales).includes(locale)) {
    return
  }

  if (useLocale().get() !== locale) {
    useLocale().set(locale)
  }
}

export { pmsLocaleManager, syncLocaleWithUserLanguage }
